module.exports = __webpack_public_path__ + "static/media/ic_configure.d97dab9d.svg";